import './App.css';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import Home from "./page/Home.js";
import AboutPage from './page/About/AboutPage.js';
import ContactPage from './page/contact/Contact.js';
function App() {
  return (
     <BrowserRouter>
   
    <Routes>
    <Route
          path="/"
          element={
            
              <Home />
            
          }
        />
        <Route
          path="/about"
          element={
            
              <AboutPage />
            
          }
        />
        <Route
          path="/contact"
          element={
            
              <ContactPage />
            
          }
        />
      </Routes>
      </BrowserRouter>
  );
}

export default App;
